import { motion } from 'framer-motion'
import { SectionLabel } from '../ui/SectionLabel'

const testimonials = [
  {
    quote: "Not only do they manage our tech to ensure we are protected and up to date, but they treat us like family. We can trust them with all of our issues and don't worry about them overpricing hardware — they find us the best price they can offer.",
    attribution: 'Suey Linzmeier, Executive Director, Head Start of Yamhill County',
  },
  {
    quote: "NextTech Consultants are the tech guys that answer promptly and resolve all my technology needs. I don't have to worry about IT anymore — it just works.",
    attribution: 'Rachel, On The Road Accounting',
  },
  {
    quote: "Maintains our network so we are secure, fast, and connected. Full service with consultation including the latest cyber security, PCI compliance, and hardware. Good communication and easy to understand estimates and invoices. The best!",
    attribution: 'Pete Miller, Caravan Coffee',
  },
]

export function Testimonials() {
  return (
    <section style={{ padding: '120px 0', background: 'var(--bg)' }}>
      <div className="max-w-6xl mx-auto px-6">
        <motion.div
          initial={false}
          animate={{ opacity: 1, y: 0 }}
          className="mb-16"
        >
          <SectionLabel className="mb-6">What Clients Say</SectionLabel>
          <h2
            style={{
              fontFamily: 'Barlow Condensed, sans-serif',
              fontWeight: 900,
              fontSize: 'clamp(38px, 5vw, 60px)',
              textTransform: 'uppercase',
              lineHeight: 1.0,
              color: 'var(--white)',
            }}
          >
            Don't take our word for it.
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-[3px]">
          {testimonials.map((t, i) => (
            <motion.div
              key={t.attribution}
              initial={false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="testimonial-card relative overflow-hidden transition-colors duration-250"
              style={{
                background: 'var(--bg-3)',
                padding: '44px 36px',
              }}
            >
              <div
                style={{
                  color: 'var(--accent)',
                  fontSize: 14,
                  letterSpacing: 3,
                  marginBottom: 20,
                }}
              >
                ★★★★★
              </div>
              <p
                style={{
                  fontSize: 16,
                  lineHeight: 1.75,
                  color: 'var(--white-dim)',
                  marginBottom: 28,
                  position: 'relative',
                  zIndex: 1,
                }}
              >
                {t.quote}
              </p>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  borderTop: '1px solid var(--white-faint)',
                  paddingTop: 20,
                }}
              >
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    background: 'var(--accent-glow)',
                    border: '1px solid var(--accent-line)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontFamily: 'Barlow Condensed, sans-serif',
                    fontWeight: 700,
                    fontSize: 15,
                    color: 'var(--accent)',
                  }}
                >
                  {t.attribution.charAt(0)}
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: 'var(--white)' }}>
                    {t.attribution.split(',')[0].trim()}
                  </div>
                  <div style={{ fontSize: 12, color: 'var(--white-dim)', marginTop: 2 }}>
                    {t.attribution.includes(',') ? t.attribution.split(',').slice(1).join(', ').trim() : ''}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Google Reviews link */}
        <div style={{
          textAlign: 'center',
          marginTop: 48,
          paddingTop: 32,
          borderTop: '1px solid rgba(238,240,245,0.08)',
        }}>
          <a
            href="https://g.page/r/CbK9In4IzuxcEBM/review"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 10,
              color: 'var(--white-dim)',
              fontSize: 14,
              fontWeight: 500,
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => (e.currentTarget.style.color = 'var(--white)')}
            onMouseLeave={e => (e.currentTarget.style.color = 'var(--white-dim)')}
          >
            {/* Google G icon */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
              <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
              <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z" fill="#FBBC05"/>
              <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
            </svg>
            See our reviews on Google →
          </a>
        </div>
      </div>
      <style dangerouslySetInnerHTML={{ __html: `
        .testimonial-card:hover { background: var(--bg-4) !important; }
        .testimonial-card::before {
          content: "\\201C";
          font-family: Georgia, serif;
          font-size: 140px;
          color: rgba(78,125,233,0.07);
          position: absolute;
          top: -8px; left: 20px;
          line-height: 1;
          pointer-events: none;
        }
      ` }} />
    </section>
  )
}
